export default __webpack_public_path__ + "032b382a91ff76575efd4a4b00e662a9.png";